var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 12,
    viewBox: "0 0 20 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.45 11.5H16.15V10.5H5.425C4.19167 10.5 3.14583 10.0625 2.2875 9.1875C1.42917 8.3125 1 7.25 1 6C1 4.76667 1.42083 3.70833 2.2625 2.825C3.10417 1.94167 4.13333 1.5 5.35 1.5H16.15C16.95 1.5 17.625 1.77917 18.175 2.3375C18.725 2.89583 19 3.575 19 4.375C19 5.175 18.725 5.85417 18.175 6.4125C17.625 6.97083 16.95 7.25 16.15 7.25H6.275C5.925 7.25 5.625 7.12917 5.375 6.8875C5.125 6.64583 5 6.35 5 6C5 5.65 5.12917 5.35417 5.3875 5.1125C5.64583 4.87083 5.95 4.75 6.3 4.75H16.15V3.75H6.325C5.69167 3.75 5.14583 3.96667 4.6875 4.4C4.22917 4.83333 4 5.36667 4 6C4 6.63333 4.22083 7.16667 4.6625 7.6C5.10417 8.03333 5.64167 8.25 6.275 8.25H16.15C17.2167 8.25 18.125 7.87083 18.875 7.1125C19.625 6.35417 20 5.44167 20 4.375C20 3.30833 19.625 2.39583 18.875 1.6375C18.125 0.879166 17.2167 0.5 16.15 0.5H5.4C3.88333 0.5 2.60417 1.0375 1.5625 2.1125C0.520833 3.1875 0 4.48333 0 6C0 7.51667 0.529167 8.8125 1.5875 9.8875C2.64583 10.9625 3.93333 11.5 5.45 11.5Z",
    fill: "black",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileIcon);
export default __webpack_public_path__ + "static/media/file-icon.b4a608dc324f8e667305dae95f7f5844.svg";
export { ForwardRef as ReactComponent };